// extracted by mini-css-extract-plugin
export default {"checkBox":"Checkbox_checkBox__+d0+v","checkmark":"Checkbox_checkmark__WcgY-"};